module.exports = __webpack_public_path__ + "img/ae865c5efaf07ab50eaaaa089e20fd50.69dfac20.png";